<template>
  <footer class="footer" :style="footerStyles">
    <img
      src="assets/logos/LogoWhite.svg"
      alt="Logo Artistic Vision"
      class="logo-footer"
    />

    <div class="social-networks">
      <a
        href="https://www.instagram.com/artisticvisionestudio?igsh=MWlxcHJiNmJlMjZicA=="
        target="_blank"
      >
        <img
          src="assets/icons/Instagram.svg"
          alt="Instagram"
          class="icon-network"
        />
      </a>
      <a href="https://wa.me/573105456982" target="_blank">
        <img
          src="assets/icons/Whatsapp.svg"
          alt="Whatsapp"
          class="icon-network"
        />
      </a>
      <a
        href="https://www.linkedin.com/company/artisticvisionstudio"
        target="_blank"
      >
        <img
          src="assets/icons/Linkedin.svg"
          alt="Linkedin"
          class="icon-network"
        />
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
  props: {
    overlayColor: {
      type: String,
      default: "var(--violet)",
      validator: (value) =>
        [
          "var(--violet)",
          "var(--dark-blue)",
          "var(--purple)",
          "var(--green)",
          "var(--light-blue)",
          "var(--yellow)",
          "var(--black)",
        ].includes(value),
    },

    backgroundImage: {
      type: String,
      default: "assets/backgrounds/BackgroundImage.png",
    },
  },

  computed: {
    footerStyles() {
      const colorMap = {
        "var(--violet)": "70, 37, 79",
        "var(--dark-blue)": "7, 60, 93",
        "var(--purple)": "116, 66, 83",
        "var(--green)": "31, 122, 140",
        "var(--light-blue)": "81, 152, 211",
        "var(--yellow)": "211, 175, 74",
        "var(--black)": "20, 20, 20",
      };

      const rgb = colorMap[this.overlayColor] || "70, 37, 79";

      return {
        background: `linear-gradient(
          rgba(${rgb}, 0.95),
          rgba(${rgb}, 0.95)
        ), url('${this.backgroundImage}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/ux/layout/styles/footerComponentStyle";
</style>